import {
  apiAddProviderCustomerMatrix,
  apiDeleteProviderCustomerMatrix,
  apiGetProviderCustomerMatrices,
  apiUpdateProviderCustomerMatrix,
} from "@lib/api/provider";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useProviderCustomerMatrixQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "provider-customer-matrix",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const providerCustomerMatricesQuery = useQuery({
    queryFn: () => apiGetProviderCustomerMatrices(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addProviderCustomerMatrixMutation = useMutation({
    mutationFn: apiAddProviderCustomerMatrix,
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.providerCustomerMatrix"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const updateProviderCustomerMatrixMutation = useMutation({
    mutationFn: apiUpdateProviderCustomerMatrix,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.providerCustomerMatrix"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const deleteProviderCustomerMatrixMutation = useMutation({
    mutationFn: apiDeleteProviderCustomerMatrix,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.providerCustomerMatrix"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    providerCustomerMatricesQuery,
    addProviderCustomerMatrixMutation,
    updateProviderCustomerMatrixMutation,
    deleteProviderCustomerMatrixMutation,
  };
};
